import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  tooltipContent: {
    backgroundColor: colors.backgroundPrimaryInverse,
    borderRadius: theme.borderRadius.xs,
    paddingHorizontal: theme.spacing[3],
    paddingVertical: theme.spacing[2],
    maxWidth: 250,
    shadowColor: colors.overlayPrimary,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
    borderWidth: 1,
  },

  tooltipText: {
    color: colors.textPrimaryInverse,
    textAlign: 'center',
  },

  modalOverlay: {
    flex: 1,
    backgroundColor: 'transparent',
  },

  modalContainer: {
    position: 'absolute',
  },
}));
